import { render, staticRenderFns } from "./TrainingService.vue?vue&type=template&id=052fb9bb&scoped=true&"
import script from "./TrainingService.vue?vue&type=script&lang=js&"
export * from "./TrainingService.vue?vue&type=script&lang=js&"
import style0 from "./TrainingService.vue?vue&type=style&index=0&id=052fb9bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052fb9bb",
  null
  
)

export default component.exports